import '@styles/user-panel.sass'
import initCv from "./forms/cv";
import initWatchdogCreator from "./forms/watchdog-create";
import {toggleFavoriteOffer} from "./utils/offer";

initWatchdogCreator()

declare global {
    const cvData: CvData
}

initCv();

(() => {
    document.querySelectorAll('[data-favorite-offer]')
        .forEach((toggle: HTMLElement) => toggle.addEventListener("click", () => toggleFavoriteOffer(toggle)))
})();
